import React from 'react';
import { Link } from 'react-router-dom';

export default class MyCourses extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            error: false,
            courses: [],
            displayCourses: [],
            categories: []
        }
    }
    componentDidMount()
    { 
        this.loadMyCourses();
    }
    loadMyCourses()
    {
        this.props.api.send({
            controller: "Course",
            action: "LoadMyCourses",
            method: "get",
            success: (response) => {
                response.success ?
                    this.setState({loaded: true, courses: response.courses, displayCourses: response.courses}) :
                    this.setState({loaded: true, error: true})
                this.getCourseCategories();
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }
    getCourseCategories()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Course",
            action: "GetCourseCategories",
            method: "get",
            success: (result) => {
                result.success ?
                    this.setState({loaded: true, categories: result.categories}) :
                    this.setState({loaded: true, error: result.message})
            },
            error: (err) => {
                this.setState({loaded: true, error: "Unable to load course categories.  Please try again later."})
            }
        })
    }
    filterChanged(e)
    {
        let filteredCourses = this.state.displayCourses;
        if(e.target.value !== "0")
            filteredCourses = this.state.courses.filter((c) => c.categoryID === Number(e.target.value))
        else
            filteredCourses = this.state.courses;
        this.setState({displayCourses: filteredCourses})
    }
    render()
    {
        const flattenedcats = []
        const flatten = (categories, level) => {
            categories.forEach(c => {
                let frontload = ""
                for (let l = 0; l < level; l++)
                {
                    frontload += " -- ";
                }
                flattenedcats.push({
                    id: c.categoryID, 
                    name: frontload + c.name
                });
                flatten(c.subcategories, level+1)
            })
        }
        flatten(this.state.categories, 0)
        const courselist = this.state.displayCourses.map((c) => 
            <tr key={c.courseID}>
                <td>{c.courseName}</td>
                <td>{c.courseDescription}</td>
                <td style={{width: "275px"}}>
                    <Link to={"/LaunchCourse/" + c.courseID} className="lmsbutton">Launch Course</Link>
                    <Link to={"/MyCourseResults/" + c.courseID} className="lmsbutton">My Results</Link>
                </td>
            </tr>
        )
        return (
            <div>
                <select className="lmsforminput" style={{marginBottom: "12px"}} 
                    onChange={(e) => this.filterChanged(e)}
                    value={this.state.category}>
                    <option value="0">-- Select a Category --</option>
                    {flattenedcats.map(f => 
                        <option key={f.id} value={f.id}>{f.name}</option>  
                    )}
                </select>
                {this.state.loaded ?
                    this.state.displayCourses.length > 0 ? (
                        <div style={{marginTop: "10px"}}>
                            <table className="lmstable" style={{marginTop: "12px"}}>
                                <tbody>
                                    <tr>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Actions</th>
                                    </tr>
                                    {courselist}
                                </tbody>
                            </table>                            
                        </div>
                    ) : (
                    <p>
                        <i>You do not currently have any courses available. Check the Course Catalog for available courses.</i>
                    </p>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/course/mycourses.js